import { IAddress } from '@faire/web-api--source/indigofair/data/IAddress';
import { IDocument } from '@faire/web-api--source/indigofair/data/IDocument';
import { ResellerCertificateType } from '@faire/web-api--source/indigofair/data/ResellerCertificateType';

export namespace IResellerCertificate {
  export enum ValidationSchema {
    /**
     * buf:lint:ignore ENUM_FIRST_VALUE_ZERO
     */
    RESELLER_ID = 'RESELLER_ID',
    GOOGLE_PLACE_ID = 'GOOGLE_PLACE_ID',
    NOT_APPLICABLE = 'NOT_APPLICABLE',
    SCHEMA_STATE_GROUP_0 = 'SCHEMA_STATE_GROUP_0',
    /**
     * @deprecated
     */
    SCHEMA_STATE_GROUP_1A = 'SCHEMA_STATE_GROUP_1A',
    /**
     * @deprecated
     */
    SCHEMA_STATE_GROUP_1B = 'SCHEMA_STATE_GROUP_1B',
    SCHEMA_STATE_GROUP_2A = 'SCHEMA_STATE_GROUP_2A',
    SCHEMA_STATE_GROUP_2B = 'SCHEMA_STATE_GROUP_2B',
    SCHEMA_STATE_GROUP_3A = 'SCHEMA_STATE_GROUP_3A',
    SCHEMA_STATE_GROUP_3B = 'SCHEMA_STATE_GROUP_3B',
    SCHEMA_STATE_GROUP_4 = 'SCHEMA_STATE_GROUP_4',
    SCHEMA_STATE_GROUP_5 = 'SCHEMA_STATE_GROUP_5',
    SCHEMA_STATE_GROUP_6 = 'SCHEMA_STATE_GROUP_6',
    SCHEMA_STATE_GROUP_7 = 'SCHEMA_STATE_GROUP_7',
    SCHEMA_STATE_GROUP_8 = 'SCHEMA_STATE_GROUP_8',
    SCHEMA_STATE_GROUP_1 = 'SCHEMA_STATE_GROUP_1',
    SCHEMA_STATE_GROUP_9 = 'SCHEMA_STATE_GROUP_9',
    SCHEMA_STATE_GROUP_10 = 'SCHEMA_STATE_GROUP_10',
    SCHEMA_STATE_GROUP_11 = 'SCHEMA_STATE_GROUP_11',
    DECLARED_NOT_ELIGIBLE = 'DECLARED_NOT_ELIGIBLE',
    ADMIN_OVERRIDE = 'ADMIN_OVERRIDE',
  }

  /**
   * Return an instance of IResellerCertificate with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IResellerCertificate>
  ): IResellerCertificate =>
    ({
      documents: [],
      ...(partial ?? {}),
    }) as IResellerCertificate;
}

export interface IResellerCertificate {
  certificate_number: string | undefined;
  expires_at: number | undefined;
  document_url: string | undefined;
  type: keyof typeof ResellerCertificateType | undefined;
  signing_name: string | undefined;
  state: string | undefined;
  ein: string | undefined;
  retailer_token: string | undefined;
  retailer_store_token: string | undefined;
  submitted_at: number | undefined;
  ssn: string | undefined;
  drivers_license_number: string | undefined;
  documents: Array<IDocument>;
  retailer_name: string | undefined;
  address: IAddress | undefined;
  business_description: string | undefined;
  validation_schema:
    | keyof typeof IResellerCertificate.ValidationSchema
    | undefined;
  google_place_id: string | undefined;
  confirmed_not_eligible_for_certificate: boolean | undefined;
}
